(function () {
  'use strict';

  var AUTO_DISMISS_MS = 4000;
  var bar = document.getElementById('lh-cart-bar');
  if (!bar) return;

  var titleEl = bar.querySelector('[data-cart-bar-title]');
  var closeBtn = bar.querySelector('[data-cart-bar-close]');
  var timerId = null;

  function clearTimer() {
    if (timerId !== null) {
      window.clearTimeout(timerId);
      timerId = null;
    }
  }

  function startTimer() {
    clearTimer();
    timerId = window.setTimeout(hide, AUTO_DISMISS_MS);
  }

  function show(productTitle) {
    titleEl.textContent = productTitle || 'Item';
    bar.setAttribute('data-state', 'visible');
    startTimer();
  }

  function hide() {
    clearTimer();
    bar.setAttribute('data-state', 'hidden');
  }

  document.addEventListener('theme:cart:popdown', function (event) {
    var variant = event && event.detail && event.detail.variant;
    var title = (variant && (variant.product_title || variant.title)) || 'Item';
    show(title);
  });

  closeBtn.addEventListener('click', hide);

  bar.addEventListener('mouseenter', clearTimer);
  bar.addEventListener('mouseleave', function () {
    if (bar.getAttribute('data-state') === 'visible') startTimer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && bar.getAttribute('data-state') === 'visible') hide();
  });
})();
